import { DataModelBuilder, SerializationContext, SerializedData } from '../../models/dto/data-model.js';
import { MapUtils } from '../../utility/map-utils.js';
import { Component } from '../core/component.js';

export class CustomerTrackingComponent extends Component {
  static readonly TYPE_ID: string = 'fc8346c74b5b408fbfafeaf7b26057f8';

  constructor(
    /**
     * A share link(generated by a business staff member) the customer clicked
     * on to get to the business.
     */
    public readonly adminShareLink: string | null,
  ) {
    super();
  }

  get $removable(): boolean {
    return false;
  }

  get $typeId(): string {
    return CustomerTrackingComponent.TYPE_ID;
  }

  static fromMap(context: SerializationContext, map: SerializedData): CustomerTrackingComponent {
    return new CustomerTrackingComponent(
        MapUtils.getOrNull<string>(map, 'adminShareLink'),
    );
  }

  toMap(context: SerializationContext): SerializedData {
    return {
      'adminShareLink': this.adminShareLink,
    };
  }

  clone(): this {
    return new CustomerTrackingComponent(
        this.adminShareLink,
    ) as this;
  }

  isSame(other: this): boolean {
    if(other === this) {
      return true;
    }

    return other.adminShareLink === this.adminShareLink;
  }
}

export class CustomerTrackingComponentBuilder extends DataModelBuilder<CustomerTrackingComponent> {
  build(context: SerializationContext, map: SerializedData): CustomerTrackingComponent {
    return CustomerTrackingComponent.fromMap(context, map);
  }
}
